import type { FC } from "react";
import { Box } from "@mantine/core";
import { useLandingLayoutStyles } from "../styles/components/LandingLayoutStyles";
import { Outlet } from "react-router-dom";
import Footer from "./Footer";
import ExtraHeader from "./ExtraHeader";

const LandingLayout: FC = () => {
    const { classes } = useLandingLayoutStyles();
    return (
        <Box className={classes.root}>
            <header>
                <ExtraHeader />
            </header>
            <main>
                <Outlet />
            </main>
            <footer>
                <Footer />
            </footer>
        </Box>
    );
};
export default LandingLayout;
